/* eslint-disable no-unused-vars */
//import { useRef, useState } from 'react';
import { useEffect, useState } from 'react';
import styles from './FilterSelect.module.scss';
import ArrowDownIcon from '@/assets/icons/arrow-down.svg?react';
import { HistoryFieldClubTypes } from '@/library/ClubHistoryHelper';

interface IProps {
  headTypeId: number;
  handleSelectOptionChanged: (option: string) => void;
  ALL_CHANGES_KEY: string;
}

export default function FilterSelect({ headTypeId, handleSelectOptionChanged, ALL_CHANGES_KEY }: IProps) {
  const [isOpen, setIsOpen] = useState(false);
  //const ALL_ACCOUNTS = [{ label: ALL_ACCOUNTS_KEY, value: ALL_ACCOUNTS_KEY }];
  const [selectedOption, setSelectedOption] = useState(ALL_CHANGES_KEY);
  const [options, setOptions] = useState([] as string[]);

  useEffect(() => {
    let optionList = [ALL_CHANGES_KEY];
    Object.entries(HistoryFieldClubTypes).forEach(([key, value]) => {
      if (value.includes(headTypeId)) {
        //exlude sub-categories, only show the main category in the dropdown list
        if (!key.includes('Hot Melt ') && !key.includes('Bag Logo ')) {
          optionList.push(key);
        }
      }
    });
    setOptions(optionList);
  }, []);

  const handleSelectOption = (option: string) => {
    setSelectedOption(option);
    setIsOpen(false);
    handleSelectOptionChanged(option);
  };

  return (
    <div className={styles.container}>
      <div className={`${styles.trigger}`} onClick={() => setIsOpen(!isOpen)}>
        <span>{selectedOption}</span>
        <ArrowDownIcon />
      </div>
      {isOpen && (
        <div className={styles.selectList}>
          {options.map((option) => (
            <div key={option} className={styles.selectItem} onClick={() => handleSelectOption(option)}>
              {option}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
